/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import Iconify from 'src/components/iconify';

export default function BaiboonMediaPreview({ open, type, url, title, onClose }) {
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    if (open) setZoom(1);
  }, [open, url]);

  if (!open || !url) return null;

  const zoomIn = () => setZoom((z) => Math.min(z + 0.25, 3));
  const zoomOut = () => setZoom((z) => Math.max(z - 0.25, 0.5));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle sx={{ pr: 6, py: 1.5 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{ pr: 4 }}>
          <Typography variant="subtitle2" noWrap sx={{ flex: 1 }}>
            {title || (type === 'pdf' ? 'ไฟล์ PDF' : 'รูปภาพ')}
          </Typography>
          {type === 'pdf' && (
            <Button
              size="small"
              variant="outlined"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<Iconify icon="fa-solid fa-up-right-from-square" width={14} />}
              sx={{ flexShrink: 0 }}
            >
              เปิดในแท็บใหม่
            </Button>
          )}
        </Stack>
        <IconButton
          aria-label="ปิด"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <Iconify icon="fa-solid fa-xmark" width={18} />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: type === 'pdf' ? 0 : 2, bgcolor: '#0f172a' }}>
        {type === 'pdf' ? (
          <Box
            component="iframe"
            src={url}
            title={title || 'PDF preview'}
            sx={{ width: '100%', height: { xs: '70vh', sm: '78vh' }, border: 0, bgcolor: '#fff' }}
          />
        ) : (
          <>
            <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 1.5 }}>
              <IconButton size="small" onClick={zoomOut} sx={{ color: '#fff', bgcolor: 'rgba(255,255,255,0.12)' }}>
                <Iconify icon="fa-solid fa-magnifying-glass-minus" width={16} />
              </IconButton>
              <Typography variant="caption" sx={{ color: '#fff', alignSelf: 'center', minWidth: 48, textAlign: 'center' }}>
                {Math.round(zoom * 100)}%
              </Typography>
              <IconButton size="small" onClick={zoomIn} sx={{ color: '#fff', bgcolor: 'rgba(255,255,255,0.12)' }}>
                <Iconify icon="fa-solid fa-magnifying-glass-plus" width={16} />
              </IconButton>
            </Stack>
            <Box
              sx={{
                overflow: 'auto',
                maxHeight: { xs: '65vh', sm: '72vh' },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
              }}
            >
              <Box
                component="img"
                src={url}
                alt={title || 'preview'}
                sx={{
                  maxWidth: '100%',
                  height: 'auto',
                  transform: `scale(${zoom})`,
                  transformOrigin: 'top center',
                  transition: 'transform 0.15s ease',
                  borderRadius: 1,
                  cursor: zoom < 3 ? 'zoom-in' : 'default',
                }}
                onClick={() => {
                  if (zoom < 3) setZoom((z) => Math.min(z + 0.25, 3));
                }}
              />
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
